export default __webpack_public_path__ + "static/media/user.73a0bc1f.png";